type ScreeningType = 'document' | 'exam' | 'ptInterview' | 'interview';

export const BASE_PATH = {
  INTERVIEW_EVALUATOR: '/v1/eval',
  RESUME_POPUP: '/v1/resume-popup',
};
export const PAGES = {
  ALL: '*',
  ROOT: '/',
  HEALTH: '/health',
  VIDEO_INTERVIEW: {
    INTERVIEWEE: {
      HOME: '/interviewee',
      ROOM: `/interviewee/room`,
      WAITING: '/interviewee/waiting',
      SETTING: '/interviewee/setting',
      CHECK_BROWSER: '/interviewee/check-browser',
      CHECK_DEVICE: '/interviewee/check-device',
    },
    INTERVIEWEE_SECURE: {
      HOME: '/secure/interviewee',
      WAITING: '/secure/interviewee/waiting',
      ROOM: `/secure/interviewee/room`,
      SETTING: '/secure/interviewee/setting',
      CHECK_BROWSER: '/secure/interviewee/check-browser',
      CHECK_DEVICE: '/secure/interviewee/check-device',
    },
    INTERVIEWER: {
      HOME: '/interviewer',
      ROOM: `/interviewer/room`,
      WAITING: '/interviewer/waiting',
      SETTING: '/interviewer/setting',
      CHECK_BROWSER: '/interviewer/check-browser',
      CHECK_DEVICE: '/interviewer/check-device',
    },
    SETTING: {
      HOME: '/setting',
    },
  },
  INTERVIEWER_EVALUATOR: {
    HOME: `${BASE_PATH.INTERVIEW_EVALUATOR}/`,
    NOTICE: {
      HOME: `${BASE_PATH.INTERVIEW_EVALUATOR}/notice`,
      READ: (sn: string) =>
        `${BASE_PATH.INTERVIEW_EVALUATOR}/notice/read/${sn}`,
    },
    QUESTION_AND_ANSWER: {
      HOME: `${BASE_PATH.INTERVIEW_EVALUATOR}/question-and-answer`,
      CREATE: `${BASE_PATH.INTERVIEW_EVALUATOR}/question-and-answer/create`,
      READ: (sn: string) =>
        `${BASE_PATH.INTERVIEW_EVALUATOR}/question-and-answer/read/${sn}`,
      EDIT: (sn: string) =>
        `${BASE_PATH.INTERVIEW_EVALUATOR}/question-and-answer/edit/${sn}`,
    },
    EVALUATION: {
      HOME: `${BASE_PATH.INTERVIEW_EVALUATOR}/evaluation`,
      OTHER_SCREENING: (screeningType: ScreeningType, screeningSn: string) =>
        `${BASE_PATH.INTERVIEW_EVALUATOR}/evaluation/${screeningType}/${screeningSn}`,
      // 에이전트는 screeningSn 스코프 아래 뷰(카드 비교 / 리포트)를 서브 세그먼트로 갖는다.
      // 아래 base 로 들어오면 카드 비교뷰로 redirect (기존 북마크/외부 링크 보존)
      AGENT_SCREENING: (screeningSn: string) =>
        `${BASE_PATH.INTERVIEW_EVALUATOR}/evaluation/agent/${screeningSn}`,
      AGENT_SCREENING_COMPARE: (screeningSn: string) =>
        `${BASE_PATH.INTERVIEW_EVALUATOR}/evaluation/agent/${screeningSn}/compare`,
      AGENT_SCREENING_REPORT: (screeningSn: string) =>
        `${BASE_PATH.INTERVIEW_EVALUATOR}/evaluation/agent/${screeningSn}/report`,
      INTERVIEW_SCREENING: (screeningSn: string) =>
        `${BASE_PATH.INTERVIEW_EVALUATOR}/evaluation/interview/${screeningSn}`,
      REPORT: (screeningSn: string) =>
        `${BASE_PATH.INTERVIEW_EVALUATOR}/evaluation/report/${screeningSn}`,
    },
    SEARCH: `${BASE_PATH.INTERVIEW_EVALUATOR}/search`,
    GUIDE: `${BASE_PATH.INTERVIEW_EVALUATOR}/guide`,
    CHANGE_PASSWORD: `${BASE_PATH.INTERVIEW_EVALUATOR}/change-password`,
    CHOICE_SERVICE: '/cus/selectProduct',
    LEGACY_EVAL: '/bbs/eval/notice/list',
    ERROR: {
      SYSTEM_ERROR: `${BASE_PATH.INTERVIEW_EVALUATOR}/system-error`,
      INVALID_SESSION: `${BASE_PATH.INTERVIEW_EVALUATOR}/invalid-session`,
    },
  },
  RESUME_POPUP: {
    HOME: '/cus/selectProduct',
    MANAGER: `${BASE_PATH.RESUME_POPUP}/manager`,
    EVAL: `${BASE_PATH.RESUME_POPUP}/eval`,
    SETTING: {
      HOME: `${BASE_PATH.RESUME_POPUP}/setting`,
      INFOGRAPHIC: `${BASE_PATH.RESUME_POPUP}/setting/infographic`,
    },
    PRINT: {
      HOME: `${BASE_PATH.RESUME_POPUP}/print`,
      PREVIEW: `${BASE_PATH.RESUME_POPUP}/print/preview`,
    },
  },
  FILE_DOWNLOAD: {
    HOME: '/mrs2/manager/bigfiles/index',
  },
};
